export const StoryDetailsStep = ({ data, onUpdate, onNext }) => {
    const handleSubmit = (e) => {
      e.preventDefault();
      if (data.theme.trim() && data.emotion.trim() && data.interests.trim()) {
        onNext();
      }
    };
  
    return (
      <form onSubmit={handleSubmit} className="space-y-8 animate-fadeIn p-4">
        <h2 className="text-2xl font-semibold text-center mb-8">
          Detaljer om berättelsen
        </h2>
  
        <div className="space-y-4">
          <label htmlFor="theme" className="block text-gray-700">
            Tema för berättelsen
          </label>
          <input
            id="theme"
            type="text"
            value={data.theme}
            onChange={(e) => onUpdate("theme", e.target.value)}
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="T.ex. Äventyr, Vänskap, Fantasy..."
            required
          />
        </div>
  
        <div className="space-y-4">
          <label htmlFor="emotion" className="block text-gray-700">
            Vilken känsla ska speglas i berättelsen?
          </label>
          <input
            id="emotion"
            type="text"
            value={data.emotion}
            onChange={(e) => onUpdate("emotion", e.target.value)}
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="T.ex. Glädje, Mod, Nyfikenhet..."
            required
          />
        </div>
  
        <div className="space-y-4">
          <label htmlFor="interests" className="block text-gray-700">
            Vad är {data.childName}s intressen?
          </label>
          <textarea
            id="interests"
            value={data.interests}
            onChange={(e) => onUpdate("interests", e.target.value)}
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 min-h-[100px]"
            placeholder="Berätta om vad barnet tycker om att göra..."
            required
          />
        </div>
  
        <button
  type="submit"
  className={`w-full text-white py-2 rounded-lg hover:opacity-90 transition ${
    data.childName.trim() && data.childAge > 0 && data.gender
      ? ""
      : "opacity-50 cursor-not-allowed"
  }`}
  style={
    data.childName.trim() && data.childAge > 0 && data.gender
      ? { background: "linear-gradient(90deg,rgb(51, 101, 126), #347fa4, rgb(51, 101, 126))" }
      : { backgroundColor: "#ccc" } // grå bakgrund när disabled
  }
  disabled={!data.childName.trim() || data.childAge <= 0 || !data.gender}
>
  Nästa
</button>
      </form>
    );
  };